(async () => {

  const { default: Swiper, Navigation } = await import("swiper");

  Swiper.use([
    Navigation
  ]);

  class headerSlider extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-swiper-header-slider]');
      const swiperType = this.swiperElement.dataset.swiperType;
      
      const sectionID = this.swiperElement.dataset.swiperHeaderSlider;
      const nextEl = '.swiper-button-next-' + sectionID;
      const prevEl = '.swiper-button-prev-' + sectionID;

      const slidesPerViewMobile = swiperType == 'ab' ? 2.4 : 1.3;
      const spaceBetweenMobile = swiperType == 'ab' ? 12 : 27;

      this.swiperOptions = {
        loop: true,
        slidesPerView: slidesPerViewMobile,
        direction: 'horizontal',
        spaceBetween: spaceBetweenMobile,
        navigation: {
          nextEl,
          prevEl
        },
        breakpoints: {
          768: {
            spaceBetween: 27,
            slidesPerView: 3
          },
          1024: {
            spaceBetween: 48,
            slidesPerView: 3
          },
          1200: {
            spaceBetween: 48,
            slidesPerView: 4
          }
        }
      }
      this.init();
    }
    init() {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      if(Shopify.designMode && this.swiperInstance) {

        window.addEventListener('shopify:section:load', () => {
          this.swiperInstance.update();
        });

        window.addEventListener('shopify:block:select', (event) => {
          this.swiperInstance.update();
          this.handleThemeEditorEvents(event);
        });
      }
    }

    /**
     * Handles the theme editor block change/edit event
     * @param {Object} event
     */
    handleThemeEditorEvents(event) {
      // Slide to slide based on the data attribute from the target and add 1 to get the slide index
      this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
    }

  }

  window.headerSlider = headerSlider;

  if (!customElements.get('header-slider')) {
    customElements.define('header-slider', headerSlider);
  }

})();
